import Axios from 'axios';

export default {

    async init(profile, token) {

        this.log("Brandsafe Config Loader initiated")

        let config = {'apps': [
                {
                    'show': false,
                    'title': 'no-module-available',
                    'container': 'not-found',
                    'route': '/not-found',
                    'js': [],
                    'css': []
                }
            ] };

        window.brandsafe_app_config = config;
try {
        const response = await Axios.get(process.env.VUE_APP_CONFIG_URL + '/web/setup?v=' + process.env.VUE_APP_MENU_VERSION, { headers: { 'Authorization': 'Bearer ' + token }});
        let data = response.data;

        data = data.hasOwnProperty('data') ? data.data : {};
        data = data.hasOwnProperty('menu') ? data.menu : {};

        if(data.hasOwnProperty('apps') && data.apps.length > 0) {
            window.brandsafe_app_config = data;
        }

        } catch(error) {
            console.log(error);
        }
    },

    log(data) {
        if (process.env.VUE_APP_ENV === 'development') {
            console.log(data)
        }
    }
}
